const loadGooglePlatform = () => new Promise((resolve, reject) => {
  const existingScript = document.querySelector('script[data-js-google-platform]');

  if (window.gapi) {
    resolve();
    return;
  }

  if (existingScript) {
    existingScript.addEventListener('load', resolve, { once: true });
    existingScript.addEventListener('error', reject, { once: true });
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://apis.google.com/js/platform.js';
  script.async = true;
  script.defer = true;
  script.dataset.jsGooglePlatform = '';
  script.addEventListener('load', resolve, { once: true });
  script.addEventListener('error', reject, { once: true });
  document.head.appendChild(script);
});

const renderGoogleCustomerReviewSurvey = (element) => {
  window.gapi?.load('surveyoptin', () => {
    window.gapi.surveyoptin.render({
      merchant_id: element.dataset.merchantId,
      order_id: element.dataset.orderId,
      email: element.dataset.email,
      delivery_country: element.dataset.deliveryCountry,
      estimated_delivery_date: element.dataset.estimatedDeliveryDate,
    });
  });
};

export const initOrderStatus = () => {
  document.querySelectorAll('[data-js-google-customer-reviews]').forEach((element) => {
    loadGooglePlatform()
      .then(() => renderGoogleCustomerReviewSurvey(element))
      .catch(() => {});
  });
};
